module.exports = __webpack_public_path__ + "static/media/ardmore.14f6c5fa.png";